<div class="container-fluid">
  <app-pagetitle
    title="Part Wise Reports"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>
  <div class="row">
    <div class="col-xl-12">
      <div class="row">
      
        <div class="col-md-2">
          <div class="form-group">
            <label>Department</label>
            <select
              class="form-control custom-select"
              (ngModelChange)="select_Department($event)"
              name="departmentName"
              id="departmentName"
              ngModel
              disableOptionCentering
              [(ngModel)]="selectedDepartment"
            >
              <option
                *ngFor="let department of departmentData"
                [ngValue]="department.departmentName"
              >
                {{ department.departmentName }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Machine</label>
            <select
              class="form-control custom-select"
              (ngModelChange)="select_Machine($event)"
              name="machineName"
              id="machineName"
              ngModel
              disableOptionCentering
              [(ngModel)]="selectedMachine"
            >
              <option
                *ngFor="let machines of filterMachine"
                [ngValue]="machines.deviceName"
              >
                {{ machines.deviceName }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label>Shift</label>
          <select
            class="form-control custom-select"
            name="shiftName"
            id="shiftName"
            ngModel
            disableOptionCentering
            (ngModelChange)="select_Shift($event)"
            [(ngModel)]="selectedShift"
          >
            <option *ngFor="let shift of shiftData" [ngValue]="shift.shiftName">
              {{ shift.shiftName }}
            </option>
          </select>
        </div>
        <div class="col-md-2" *ngIf="isPartdata">
          <div class="form-group">
            <label>Part Name</label>
            <select
              class="form-control custom-select"
              (ngModelChange)="select_part($event)"
              name="partName"
              id="partName"
              ngModel
              disableOptionCentering
              [(ngModel)]="selectedpart"
            >
              <option *ngFor="let parts of partData" [ngValue]="parts.partName">
                {{ parts.partName }}
              </option>
            </select>
          </div>
        </div>
          <div class="form-group col-md-2">
          <label>Date</label>
          <input
            class="form-control"
            type="date"
            (ngModelChange)="select_Date($event)"
            [(ngModel)]="fromDate"
            placeholder="{{ 'From-date' }}"
            id="example-date-input"
            [min]="mindate"
            [max]="maxdate"
          />
        </div>
        <div class="col-md-1">
          <button
            style="width: 100%; margin-top: 1.8rem"
            type="button"
            class="btn btn-success btn-rounded"
            (click)="getData()"
          >
            Submit
          </button>
        </div>
        <div
          class="col-md-1"
          *ngIf="showTable && tableData['hourlyData']?.length > 0"
        >
          <button
            type="button"
            style="width: 100%; margin-top: 1.8rem"
            class="btn btn-primary btn-rounded"
            (click)="openModal(templatepdf, 'downloadpdfcsv', 'Export')"
          >
            Export
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="card flex-fill">
        <div class="card-body">
          <div
            echarts
            [options]="availabilityChart"
              (chartInit)="onChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 100%; min-height: 200px"
          ></div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card flex-fill">
        <div class="card-body">
          <div
            echarts
            [options]="productionChart"
            (chartInit)="onProductionChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 100%; min-height: 200px"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card flex-fill">
        <div class="card-body">
          <div
            echarts
            [options]="hourlyproductionChart"
             (chartInit)="onHourProductionChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 100%; min-height: 250px"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header"
          style="background-color: #0e7d79 !important; color: white"
        >
          Production
        </div>
        <div class="card-body">
          <div
            *ngIf="tableData['hourlyData']?.length > 0"
            class="table-responsive table-container"
          >
            <table
              class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0"
            >
              <thead class="thead-dark">
                <tr>
                  <th></th>
                  <th>Hour</th>
                  <th>Machine Name</th>
                  <th>Shift Name</th>
                  <th>Qty Planned</th>
                  <th *ngIf="!hasPin2">Qty Produced</th>
                  <th *ngIf="hasPin2">Partcount 1</th>
                  <th *ngIf="hasPin2">Partcount 2</th>
                  <th>Qty Rejected</th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  *ngFor="
                    let row of tableData['hourlyData']
                      | slice : pageSize
                      | slice : 0 : itemsPerPage;
                    let i = index
                  "
                >
                  <tr>
                    <td>
                      <button
                        class="btn btn-sm btn-primary"
                        (click)="toggleRow(i)"
                      >
                        {{ expandedRowIndex === i ? "-" : "+" }}
                      </button>
                    </td>
                    <td>{{ row?.hour || "00:00:00" }}</td>
                    <td>{{ row?.machine || "NA" }}</td>
                    <td>{{ row?.shift || "NA" }}</td>
                    <td>{{ row?.planned || 0 }}</td>
                    <td *ngIf="!hasPin2">{{ row?.pin1Count || 0 }}</td>
                    <td *ngIf="hasPin2">{{ row?.pin1Count || 0 }}</td>
                    <td *ngIf="hasPin2">{{ row?.pin2Count || 0 }}</td>
                    <td>{{ row?.rejected || 0 }}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td colspan="6" style="padding: 0; border: none">
                      <div
                        [@detailExpand]="
                          expandedRowIndex === i ? 'expanded' : 'collapsed'
                        "
                        style="overflow: hidden"
                      >
                        <ng-container *ngIf="row.details?.length; else noParts">
                          <table class="table table-bordered mb-0">
                            <thead class="thead-dark">
                              <tr>
                                <th>Part Name</th>
                                <th>From Time</th>
                                <th>To Time</th>
                                <th>Duration</th>
                                <th>Qty Planned</th>
                                <th *ngIf="!hasPin2">Qty Produced</th>
                                <th *ngIf="hasPin2">Partcount 1</th>
                                <th *ngIf="hasPin2">Partcount 2</th>
                                <th>Qty Rejected</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let detail of row.details">
                                <td>{{ detail?.partName || "NA" }}</td>
                                <td>{{ detail?.fromTime || "00:00:00" }}</td>
                                <td>{{ detail?.toTime || "00:00:00" }}</td>
                                <td>{{ detail?.duration || "00:00:00" }}</td>
                                <td>{{ detail?.planned || 0 }}</td>
                                <td *ngIf="!hasPin2">{{ detail?.pin1Count || 0 }}</td>
                                <td *ngIf="hasPin2">{{ detail?.pin1Count || 0 }}</td>
                                <td *ngIf="hasPin2">{{ detail?.pin2Count || 0 }}</td>
                                <td>{{ detail?.rejected || 0 }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </ng-container>
                        <ng-template #noParts>
                          <div class="p-2 text-muted text-center border">
                            No part run in this hour
                          </div>
                        </ng-template>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <ngb-pagination
              class="pagination-rounded"
              [collectionSize]="tableData['hourlyData']?.length"
              [pageSize]="itemsPerPage"
              [(page)]="currentPage"
              [maxSize]="1"
              [rotate]="true"
              [ellipses]="false"
              [boundaryLinks]="true"
              (pageChange)="onPageChange($event)"
            >
            </ngb-pagination>
          </div>
          <div
            *ngIf="
              !showTable && (!tableData['hourlyData'] || tableData['hourlyData']?.length === 0)
            "
            class="text-center text-muted"
          >
            No data available for the selected Date and Depatment, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header"
          style="background-color: #0e7d79 !important; color: white"
        >
          Downtime Entry
        </div>
        <div class="card-body">
          <div
            *ngIf="tableData['downtimeReasonData']?.length > 0"
            class="table-responsive table-container"
          >
            <table class="table table-striped table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Machine Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="filters.machineName = ''; applyFilters()"
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of machineOptions"
                            (click)="filters.machineName = opt; applyFilters()"
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Part Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="filters.partName = ''; applyFilters()"
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of partOptions"
                            (click)="filters.partName = opt; applyFilters()"
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Shift Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="filters.shiftName = ''; applyFilters()"
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of shiftOptions"
                            (click)="filters.shiftName = opt; applyFilters()"
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Status</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="filters.status = ''; applyFilters()"
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of statusOptions"
                            (click)="filters.status = opt; applyFilters()"
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>Time (hrs)</th>
                  <th>Duration (hrs)</th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Reason</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="filters.reason = ''; applyFilters()"
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of reasonOptions"
                            (click)="filters.reason = opt; applyFilters()"
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>SubReason</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div
                          class="dropdown-menu dropdown-menu-right"
                          ngbDropdownMenu
                        >
                          <button
                            class="dropdown-item"
                            (click)="filters.subreason = ''; applyFilters()"
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of subreasonOptions"
                            (click)="filters.subreason = opt; applyFilters()"
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  *ngFor="
                    let machine of filteredData
                      | slice : downtimepageSize
                      | slice : 0 : downtimeitemsPerPage
                  "
                >
                  <td>{{ machine?.machineName || "-" }}</td>
                  <td>{{ machine?.partName || "-" }}</td>
                  <td>{{ machine?.shiftName || "-" }}</td>
                  <td>{{ machine?.status || "-" }}</td>
                  <td>
                    {{
                      machine.reason !== "Not Specified"
                        ? machine.fromTime + " - " + machine.toTime
                        : "Unavailable"
                    }}
                  </td>

                  <td>{{ machine?.duration || "00:00:00" }}</td>
                  <td>{{ machine?.reason || "NA" }}</td>
                  <td>{{ machine?.subreason || "NA" }}</td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="filteredData?.length"
                [pageSize]="downtimeitemsPerPage"
                [(page)]="currendowntimetPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="ondowntimePageChange($event)"
              >
              </ngb-pagination>
            </div>
          </div>
          <div *ngIf=" !isPartdata || tableData['downtimeReasonData']?.length === 0" class="text-center text-muted">
            No data available for the selected Date and Depatment, as no
            production planning was scheduled. 
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header"
          style="background-color: #0e7d79 !important; color: white"
        >
          Rejection Entry
        </div>
        <div class="card-body">
          <div
            *ngIf="rejectionfilteredData?.length > 0"
            class="table-responsive table-container"
          >
            <table class="table table-striped table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Machine Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="
                              rejectionfilters.machineName = '';
                              applyrejectionFilters()
                            "
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of machinerejectionOptions"
                            (click)="
                              rejectionfilters.machineName = opt;
                              applyrejectionFilters()
                            "
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Part Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="
                              rejectionfilters.partName = '';
                              applyrejectionFilters()
                            "
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of partrejectionOptions"
                            (click)="
                              rejectionfilters.partName = opt;
                              applyrejectionFilters()
                            "
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Shift Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="
                              rejectionfilters.shiftName = '';
                              applyrejectionFilters()
                            "
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of shiftrejectionOptions"
                            (click)="
                              rejectionfilters.shiftName = opt;
                              applyrejectionFilters()
                            "
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Reason</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="
                              rejectionfilters.reason = '';
                              applyrejectionFilters()
                            "
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of reasonrejectionOptions"
                            (click)="
                              rejectionfilters.reason = opt;
                              applyrejectionFilters()
                            "
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>

                  <th>Count</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  *ngFor="
                    let machine of rejectionfilteredData
                      | slice : rejectionpageSize
                      | slice : 0 : rejectionitemsPerPage
                  "
                >
                  <td>{{ machine?.machineName || "-" }}</td>
                  <td>{{ machine?.partName || "-" }}</td>
                  <td>{{ machine?.shiftName || "-" }}</td>
                  <td>{{ machine?.reason || "-" }}</td>
                  <td>{{ machine?.count || "0" }}</td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="rejectionfilteredData?.length"
                [pageSize]="rejectionitemsPerPage"
                [(page)]="currenrejectiontPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="onrejectionPageChange($event)"
              >
              </ngb-pagination>
            </div>
          </div>
          <div
            *ngIf="!isPartdata || rejectionfilteredData?.length === 0"
            class="text-center text-muted"
          >
            No data available for the selected Date and Depatment, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>

   <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header"
          style="background-color: #0e7d79 !important; color: white"
        >
          Operator Comments
        </div>
        <div class="card-body">
          <div
            *ngIf="commentfilteredData?.length > 0"
            class="table-responsive table-container"
          >
            <table class="table table-striped table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Operator Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="
                              commentfilters.operatorName = '';
                              applycommentFilters()
                            "
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of operatorcommentOptions"
                            (click)="
                              commentfilters.operatorName = opt;
                              applycommentFilters()
                            "
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                   <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Machine Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="
                              commentfilters.machineName = '';
                              applycommentFilters()
                            "
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of machinecommentOptions"
                            (click)="
                              commentfilters.machineName = opt;
                              applycommentFilters()
                            "
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>Shift Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button
                            class="dropdown-item"
                            (click)="
                              commentfilters.shiftId = '';
                              applycommentFilters()
                            "
                          >
                            All
                          </button>
                          <button
                            class="dropdown-item"
                            *ngFor="let opt of shiftcommentOptions"
                            (click)="
                              commentfilters.shiftId = opt;
                              applycommentFilters()
                            "
                          >
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>Part Name</th>
                  <th>Comment</th>
                  <th>Time</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  *ngFor="
                    let machine of commentfilteredData
                      | slice : commentpageSize
                      | slice : 0 : commentitemsPerPage
                  "
                >
                 <td>{{ machine?.operatorName || "-" }}</td>
                  <td>{{selectedMachine || "-" }}</td>
                  <td>{{ machine?.usershiftId || "-" }}</td>
                  <td>{{ machine?.partName || "-" }}</td>
                  <td class="comment-column">
                    {{ machine?.commentText || "-" }}
                  </td>
                  <td>{{ machine?.createdAt || "-" }}</td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="commentfilteredData?.length"
                [pageSize]="commentitemsPerPage"
                [(page)]="currencommenttPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="oncommentPageChange($event)"
              >
              </ngb-pagination>
            </div>
          </div>
          <div
            *ngIf="!isPartdata || commentfilteredData?.length === 0"
            class="text-center text-muted"
          >
            No data available for the selected Date and Depatment, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #templatepdf role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }}</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click'); cancel()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <ul
        ngbNav
        #justifiednav="ngbNav"
        [activeId]="1"
        class="nav-pills nav-justified"
      >
        <li (click)="directExpo()" [ngbNavItem]="1">
          <a ngbNavLink>
            <h6 class="">Direct Export</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="directExport"></ng-template>
          </ng-template>
        </li>
        <li (click)="mailexport()" [ngbNavItem]="2">
          <a ngbNavLink>
            <h6 class="">Export via Email</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="mailExport"></ng-template>
          </ng-template>
        </li>
      </ul>
      &nbsp;&nbsp;
      <div [ngbNavOutlet]="justifiednav"></div>
      <div class="text-right mt-3">
        <button
          *ngIf="!exportViaMail"
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()"
        >
          Export
        </button>
        <button
          *ngIf="exportViaMail"
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()"
          [disabled]="!mailform.get('email').value"
        >
          Export
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #directExport>
  <form>
    <div>
      <p>Select the file type you would like to export</p>
    </div>
    <span
      class="pdf"
      [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
      ><i class="fas fa-file-pdf" (click)="pdf()"> PDF </i></span
    >&nbsp;&nbsp;
    <span
      class="csv"
      [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
      ><i class="fas fa-file-csv" (click)="csv()"> CSV </i></span
    >
    &nbsp;&nbsp;
  </form>
</ng-template>
<ng-template #mailExport>
  <div>
    <p>Select the file type you would like to export</p>
  </div>
  <span
    class="pdf"
    [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
    ><i class="fas fa-file-pdf" (click)="pdf()"> PDF </i></span
  >&nbsp;&nbsp;
  <span
    class="csv"
    [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
    ><i class="fas fa-file-csv" (click)="csv()"> CSV </i></span
  >&nbsp;&nbsp;
  <div>
    <form [formGroup]="mailform">
      <div class="form-group col-md-8">
        &nbsp;&nbsp;

        <input
          class="form-control"
          id="email"
          placeholder="user@gmail.com"
          formControlName="email"
          required
          [ngClass]="{ 'is-invalid': isEmailInvalid() }"
        />
        <div *ngIf="isEmailInvalid()">
          <span *ngIf="email.hasError('required')" style="color: red"
            >Email is required</span
          >
          <span *ngIf="email.hasError('email')" style="color: red"
            >Invalid email address</span
          >
        </div>
      </div>
    </form>
  </div>
</ng-template>
